import { DatePickerCellStatusProp } from "../../interface";
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.extend(isSameOrBefore);
import moment from 'moment';
export function generateVirtualCell(tableCells, rowIndex, columnIndex, value) {
  tableCells.push({
    rowIndex: rowIndex,
    columnIndex: columnIndex,
    value: value,
    virtual: true
  });
}
export function generateRealCell(tableCells, rowIndex, columnIndex, value, dMonth, day, blockCells, checkoutOnlyCells, unavailableDueToMinimumStayCells) {
  var date = dMonth.add(day - 1, 'day').format('YYYY-MM-DD');
  var status = DatePickerCellStatusProp.Normal;
  var blockCell = getBlockCell(blockCells, date);
  var checkoutOnlyCell = getCheckoutOnlyCell(checkoutOnlyCells, date);
  var unavailableDueToMinimumStayCell = getUnavailableDueToMinimumStayCells(unavailableDueToMinimumStayCells, date);
  if (blockCell) {
    status = DatePickerCellStatusProp.Block;
  }
  if (checkoutOnlyCell) {
    status = DatePickerCellStatusProp.CheckoutOnly;
  }
  if (unavailableDueToMinimumStayCell) {
    status = DatePickerCellStatusProp.UnavailableDueToMinimumStay;
  }
  tableCells.push({
    rowIndex: rowIndex,
    columnIndex: columnIndex,
    date: date,
    value: value,
    status: status,
    day: day,
    virtual: false
  });
}
export function generateDatesFromStartAndEnd(startDate, endDate) {
  var start = moment(startDate).startOf('day');
  var end = moment(endDate).startOf('day');
  var dateArray = [];
  while (start <= end) {
    dateArray.push(start.format('YYYY-MM-DD'));
    start.add(1, 'days');
  }
  return dateArray;
}
export function generateBlockTableCells(blockDates) {
  var blockCells = [];
  for (var k = 0; k < blockDates.length; k++) {
    blockCells.push({
      date: blockDates[k],
      value: blockDates[k]
    });
  }
  return blockCells;
}
export function generateCheckoutOnlyTableCells(checkoutOnlyDates) {
  var checkoutOnlyCells = [];
  for (var k = 0; k < checkoutOnlyDates.length; k++) {
    checkoutOnlyCells.push({
      date: checkoutOnlyDates[k],
      value: checkoutOnlyDates[k]
    });
  }
  return checkoutOnlyCells;
}
export function generateUnavailableDueToMinimumStayCells(unavailableDueToMinimumStayCells) {
  var checkoutOnlyCells = [];
  for (var k = 0; k < unavailableDueToMinimumStayCells.length; k++) {
    checkoutOnlyCells.push({
      date: unavailableDueToMinimumStayCells[k],
      value: unavailableDueToMinimumStayCells[k]
    });
  }
  return checkoutOnlyCells;
}
export function getBlockCell(blockCells, date) {
  var _blockCells$filter;
  return (_blockCells$filter = blockCells.filter(function (i) {
    return i.date === date;
  })) === null || _blockCells$filter === void 0 ? void 0 : _blockCells$filter[0];
}
export function getCheckoutOnlyCell(checkoutOnlyCells, date) {
  var _checkoutOnlyCells$fi;
  return (_checkoutOnlyCells$fi = checkoutOnlyCells.filter(function (i) {
    return i.date === date;
  })) === null || _checkoutOnlyCells$fi === void 0 ? void 0 : _checkoutOnlyCells$fi[0];
}
export function getUnavailableDueToMinimumStayCells(unavailableDueToMinimumStayCells, date) {
  var _unavailableDueToMini;
  return (_unavailableDueToMini = unavailableDueToMinimumStayCells.filter(function (i) {
    return i.date === date;
  })) === null || _unavailableDueToMini === void 0 ? void 0 : _unavailableDueToMini[0];
}
export function generateTableCells(monthDate, blockDates, checkoutOnlyDates, unavailableDueToMinimumStayDates) {
  var tableCells = [];
  var allMonths = Object.keys(monthDate);
  var rowIndex = -1;
  var blockCells = generateBlockTableCells(blockDates);
  var checkoutOnlyCells = generateCheckoutOnlyTableCells(checkoutOnlyDates);
  var unavailableDueToMinimumStayCells = generateUnavailableDueToMinimumStayCells(unavailableDueToMinimumStayDates);
  for (var i = 0; i < allMonths.length; i++) {
    rowIndex = rowIndex + 1;
    var month = allMonths[i];
    var dMonth = dayjs(month);

    // first row
    generateVirtualCell(tableCells, rowIndex, 0, dMonth.format('MMMM YYYY'));
    for (var j = 1; j < 7; j++) {
      generateVirtualCell(tableCells, rowIndex, j, '');
    }

    // rest row
    var daysInMonth = dMonth.daysInMonth();
    var startDay = dMonth.startOf('month').day();
    rowIndex = rowIndex + 1;
    for (var _j = 0; _j < startDay; _j++) {
      generateVirtualCell(tableCells, rowIndex, _j, '');
    }
    for (var _j2 = startDay; _j2 < 7; _j2++) {
      generateRealCell(tableCells, rowIndex, _j2, '', dMonth, _j2 - startDay + 1, blockCells, checkoutOnlyCells, unavailableDueToMinimumStayCells);
    }
    var rowNumber = Math.ceil((daysInMonth - (7 - startDay)) / 7);
    for (var _j3 = 1; _j3 <= rowNumber; _j3++) {
      rowIndex = rowIndex + 1;
      if (_j3 !== rowNumber) {
        for (var k = 0; k < 7; k++) {
          generateRealCell(tableCells, rowIndex, k, '', dMonth, 7 - startDay + 1 + k + (_j3 - 1) * 7, blockCells, checkoutOnlyCells, unavailableDueToMinimumStayCells);
        }
      } else {
        for (var _k = 0; _k < 7; _k++) {
          var day = 7 - startDay + 1 + _k + (_j3 - 1) * 7;
          if (day > daysInMonth) {
            generateVirtualCell(tableCells, rowIndex, _k, '');
          } else {
            generateRealCell(tableCells, rowIndex, _k, '', dMonth, day, blockCells, checkoutOnlyCells, unavailableDueToMinimumStayCells);
          }
        }
      }
    }
  }
  return tableCells;
}
export function getTableCell(tableCells, rowIndex, columnIndex) {
  var _tableCells$filter;
  return (_tableCells$filter = tableCells.filter(function (i) {
    return i.rowIndex === rowIndex && i.columnIndex === columnIndex;
  })) === null || _tableCells$filter === void 0 ? void 0 : _tableCells$filter[0];
}
export function getColumnBackgroundSelectedStyle(rowIndex, columnIndex, selection) {
  var rowStartIndex = selection.rowStartIndex,
    rowEndIndex = selection.rowEndIndex,
    columnStartIndex = selection.columnStartIndex,
    columnEndIndex = selection.columnEndIndex;
  if (rowStartIndex === rowIndex && columnStartIndex === columnIndex) {
    return 'date-picker-table-row-column-selected-start-container';
  }
  if (rowEndIndex === rowIndex && columnEndIndex === columnIndex) {
    return 'date-picker-table-row-column-selected-end-container';
  }
  if (rowStartIndex !== rowEndIndex) {
    if (rowEndIndex !== -1 && columnEndIndex !== -1 && (rowIndex === rowStartIndex && columnIndex >= columnStartIndex && columnIndex < 7 || rowIndex > rowStartIndex && rowIndex < rowEndIndex && columnIndex >= 0 && columnIndex < 7 || rowIndex === rowEndIndex && columnIndex >= 0 && columnIndex <= columnEndIndex)) {
      return 'date-picker-table-row-column-selected-background-container';
    }
  } else {
    if (rowEndIndex !== -1 && columnEndIndex !== -1 && columnIndex >= columnStartIndex && columnIndex <= columnEndIndex && rowIndex >= rowStartIndex && rowIndex <= rowEndIndex) {
      return 'date-picker-table-row-column-selected-background-container';
    }
  }
  return '';
}
function checkIsCellDisabledAfterFirstSelection(tableCell, firstSelection, minRange, maxRange, tableCells, blockCells, checkoutOnlyCells) {
  //if virtual cell, no need to disable
  if (tableCell.virtual || !tableCell.date) return {
    disableIfSameOrBefore: false,
    disableIfAfter: false
  };

  //if no firstSelection, no need to disable cells
  if (firstSelection.current.rowCurrentIndex === -1) return {
    disableIfSameOrBefore: false,
    disableIfAfter: false
  };

  // check disable after first selection
  var firstSelectionCell = getTableCell(tableCells, firstSelection.current.rowCurrentIndex, firstSelection.current.columnCurrentIndex);
  var cellDate = tableCell.date;
  var startDate = firstSelectionCell.date;

  // Parse dates using dayjs
  var startDayjs = dayjs(startDate);
  var cellDayjs = dayjs(cellDate);

  // Only consider cells after the start cell
  if (cellDayjs.isSameOrBefore(startDayjs, 'day')) return {
    disableIfSameOrBefore: false,
    disableIfAfter: true
  };

  // Determine the minimum and maximum range dates
  var minRangeEndDate = startDayjs.add(minRange - 1, 'day');
  var maxRangeEndDate = startDayjs.add(maxRange, 'day');
  // Find the closest blocked date after startDayjs
  var closestBlockedDateAfterStart = blockCells.map(function (dateStr) {
    return dayjs(dateStr);
  }) // Convert strings to dayjs objects
  .filter(function (blockedDate) {
    return blockedDate.isAfter(startDayjs, 'day');
  }) // Keep only dates after startDayjs
  .sort(function (a, b) {
    return a.diff(b);
  }) // Sort to find the closest date
  .shift(); // Get the first (closest) date in the sorted array
  var closestCheckoutDateAfterStart = checkoutOnlyCells.map(function (dateStr) {
    return dayjs(dateStr);
  }) // Convert strings to dayjs objects
  .filter(function (blockedDate) {
    return blockedDate.isAfter(startDayjs, 'day');
  }) // Keep only dates after startDayjs
  .sort(function (a, b) {
    return a.diff(b);
  }) // Sort to find the closest date
  .shift(); // Get the first (closest) date in the sorted array

  // Determine which of the closestBlockedDate or closestCheckoutDate is closer to startDayjs
  var closestDateAfterStart = closestBlockedDateAfterStart && closestCheckoutDateAfterStart ? closestBlockedDateAfterStart.isBefore(closestCheckoutDateAfterStart, 'day') ? closestBlockedDateAfterStart : closestCheckoutDateAfterStart : closestBlockedDateAfterStart || closestCheckoutDateAfterStart;

  // Update maxRangeEndDate to the closest date if it’s within the range
  if (closestDateAfterStart && closestDateAfterStart.isBefore(maxRangeEndDate, 'day')) {
    maxRangeEndDate = closestDateAfterStart;
  }

  // Disable cells if they fall outside the allowed range after the start cell
  return {
    disableIfSameOrBefore: cellDayjs.isSameOrBefore(minRangeEndDate, 'day'),
    disableIfAfter: cellDayjs.isAfter(maxRangeEndDate, 'day')
  };
}
export function getColumnStatusStyle(tableCells, tableCell, firstSelection, minRange, maxRange, blockCells, checkoutOnlyCells) {
  if (tableCell && !tableCell.virtual) {
    if (dayjs(tableCell.date).isBefore(dayjs().subtract(1, 'day'))) {
      return 'date-picker-table-row-column-disabled-container';
    } else if (dayjs(tableCell.date).isAfter(dayjs().subtract(1, 'day'))) {
      if (firstSelection.current.rowCurrentIndex !== -1) {
        var _checkIsCellDisabledA = checkIsCellDisabledAfterFirstSelection(tableCell, firstSelection, minRange, maxRange, tableCells, blockCells, checkoutOnlyCells),
          disableIfSameOrBefore = _checkIsCellDisabledA.disableIfSameOrBefore,
          disableIfAfter = _checkIsCellDisabledA.disableIfAfter;
        if (disableIfSameOrBefore) {
          return 'date-picker-table-row-column-arrival-unavailable-tooltip';
        } else if (disableIfAfter) {
          return 'date-picker-table-row-column-disabled-container';
        } else {
          return '';
        }
      }
      if (tableCell.status === 'Block') {
        return 'date-picker-table-row-column-disabled-container';
      }
      if (tableCell.status === 'CheckoutOnly' || tableCell.status === 'UnavailableDueToMinimumStay') {
        return 'date-picker-table-row-column-arrival-unavailable-tooltip';
      }
    }
  }
  return '';
}
export function getColumnVirtualStyle(tableCells, rowIndex, columnIndex) {
  var tableCell = getTableCell(tableCells, rowIndex, columnIndex);
  if (tableCell && tableCell.virtual) {
    return 'date-picker-table-row-column-virtual-container';
  }
  return '';
}
export function getTableCellVirtualCondition(tableCells, rowIndex, columnIndex) {
  var tableCell = getTableCell(tableCells, rowIndex, columnIndex);
  return tableCell === null || tableCell === void 0 ? void 0 : tableCell.virtual;
}
export function getSelectedTableStartEndCell(tableCells, rowStartIndex, rowEndIndex, columnStartIndex, columnEndIndex) {
  // const numberOfColumns = 7; // hard coded 7

  return tableCells.filter(function (i) {
    var isWithinRowRange = i.rowIndex === rowStartIndex && i.columnIndex === columnStartIndex ||
    // Row 3, columns 4 to 6
    i.rowIndex === rowEndIndex && i.columnIndex === columnEndIndex; // Row 4, columns 0 to 2

    return isWithinRowRange;
  });
}
export function getTableColumnCellsByStartAndEnd(tableCells, columnStartIndex, columnEndIndex, rowStartIndex, rowEndIndex) {
  return tableCells.filter(function (i) {
    return i.columnIndex >= columnStartIndex && i.columnIndex <= columnEndIndex && i.rowIndex >= rowStartIndex && i.rowIndex <= rowEndIndex;
  });
}
export function getTableColumnCells(tableCells, rowStartIndex, rowEndIndex, columnStartIndex, columnEndIndex, rowIndex) {
  if (rowStartIndex !== rowEndIndex) {
    if (rowIndex === rowStartIndex) {
      return tableCells.filter(function (i) {
        return i.columnIndex >= columnStartIndex && i.columnIndex < 7 && i.rowIndex === rowIndex;
      });
    } else if (rowIndex > rowStartIndex && rowIndex < rowEndIndex) {
      return tableCells.filter(function (i) {
        return i.columnIndex >= 0 && i.columnIndex < 7 && i.rowIndex === rowIndex;
      });
    } else if (rowIndex === rowEndIndex) {
      return tableCells.filter(function (i) {
        return i.columnIndex >= 0 && i.columnIndex <= columnEndIndex && i.rowIndex === rowIndex;
      });
    } else {
      return [];
    }
  } else {
    return tableCells.filter(function (i) {
      return i.columnIndex >= columnStartIndex && i.columnIndex <= columnEndIndex && i.rowIndex === rowIndex;
    });
  }
}
export function onScrollDate(params, rowHeight, tableCells, props) {
  var number = Math.round(params.scrollTop / rowHeight);
  var tableCell = getTableCell(tableCells, number, 0);
  if (tableCell !== null && tableCell !== void 0 && tableCell.virtual && tableCell !== null && tableCell !== void 0 && tableCell.value) {
    props.setMonthTitle(tableCell.value);
    var dayjsObj = dayjs(tableCell.value, 'MMMM YYYY');
    props.setMonthlyTitleSelectedDate(dayjsObj);
  } else if (tableCell !== null && tableCell !== void 0 && tableCell.date) {
    var date = new Date(tableCell.date);
    var options = {
      year: 'numeric',
      month: 'long'
    };
    var formattedDate = date.toLocaleDateString('en-US', options);
    var _dayjsObj = dayjs(formattedDate, 'MMMM YYYY');
    props.setMonthlyTitleSelectedDate(_dayjsObj);
    props.setMonthTitle(formattedDate);
  }
}

//clear both first and second selection
function clearSelection(firstSelection) {
  var defaultValue = {
    rowStartIndex: -1,
    rowEndIndex: -1,
    rowCurrentIndex: -1,
    columnStartIndex: -1,
    columnEndIndex: -1,
    columnCurrentIndex: -1
  };
  firstSelection.current = defaultValue;
}
export function onMouseDown(rowIndex, columnIndex, selectionVisible, setSelectionVisible, setSelection, tableCells, tableCell, firstSelection, minRange, maxRange, blockCells, checkoutOnlyCells, setArrivalUnavailableCell) {
  //for desktop user
  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) return;
  if (tableCell.status === 'Block') return;

  //handle tooltip, if this is the first selection, do not allow selection action, display tooltip
  if (firstSelection.current.rowCurrentIndex === -1 && (tableCell.status === 'CheckoutOnly' || tableCell.status === 'UnavailableDueToMinimumStay')) {
    setArrivalUnavailableCell({
      key: "".concat(tableCell.rowIndex, "-").concat(tableCell.columnIndex),
      status: tableCell.status
    });
    return;
  } else {
    setArrivalUnavailableCell({
      key: '',
      status: ''
    });
  }
  if (tableCell && !tableCell.virtual && dayjs(tableCell.date).isAfter(dayjs().subtract(1, 'day'))) {
    if (!selectionVisible) {
      var currentSelection = {
        rowStartIndex: rowIndex,
        rowEndIndex: rowIndex,
        rowCurrentIndex: rowIndex,
        columnStartIndex: columnIndex,
        columnEndIndex: columnIndex,
        columnCurrentIndex: columnIndex
      };
      setSelection(currentSelection);
      firstSelection.current = currentSelection;
      setSelectionVisible(true);
    } else {
      //check if disabled cell click after first selection
      var _checkIsCellDisabledA2 = checkIsCellDisabledAfterFirstSelection(tableCell, firstSelection, minRange, maxRange, tableCells, blockCells, checkoutOnlyCells),
        disableIfSameOrBefore = _checkIsCellDisabledA2.disableIfSameOrBefore,
        disableIfAfter = _checkIsCellDisabledA2.disableIfAfter;
      if (disableIfSameOrBefore) {
        setArrivalUnavailableCell({
          key: "".concat(tableCell.rowIndex, "-").concat(tableCell.columnIndex),
          status: 'UnavailableDueToMinimumStay'
        });
        return;
      } else if (disableIfAfter) {
        return;
      } else {
        setArrivalUnavailableCell({
          key: '',
          status: ''
        });
      }
      clearSelection(firstSelection);
      setSelectionVisible(false);
    }
  }
}
export function onTouchEnd(rowIndex, columnIndex, selectionVisible, setSelectionVisible, setSelection, selection, tableCells, tableCell, firstSelection, minRange, maxRange, blockCells, checkoutOnlyCells, setArrivalUnavailableCell) {
  //for mobile touch screen user
  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (!isMobile) return;
  if (tableCell.status === 'Block') return;

  //handle tooltip, if this is the first selection, do not allow selection action, display tooltip
  if (firstSelection.current.rowCurrentIndex === -1 && (tableCell.status === 'CheckoutOnly' || tableCell.status === 'UnavailableDueToMinimumStay')) {
    setArrivalUnavailableCell({
      key: "".concat(tableCell.rowIndex, "-").concat(tableCell.columnIndex),
      status: tableCell.status
    });
    return;
  } else {
    setArrivalUnavailableCell({
      key: '',
      status: ''
    });
  }
  if (tableCell && !tableCell.virtual && dayjs(tableCell.date).isAfter(dayjs().subtract(1, 'day'))) {
    if (!selectionVisible) {
      var currentSelection = {
        rowStartIndex: rowIndex,
        rowEndIndex: rowIndex,
        rowCurrentIndex: rowIndex,
        columnStartIndex: columnIndex,
        columnEndIndex: columnIndex,
        columnCurrentIndex: columnIndex
      };
      setSelection(currentSelection);
      firstSelection.current = currentSelection;
      setSelectionVisible(true);
    } else {
      //check if disabled cell click after first selection
      var _checkIsCellDisabledA3 = checkIsCellDisabledAfterFirstSelection(tableCell, firstSelection, minRange, maxRange, tableCells, blockCells, checkoutOnlyCells),
        disableIfSameOrBefore = _checkIsCellDisabledA3.disableIfSameOrBefore,
        disableIfAfter = _checkIsCellDisabledA3.disableIfAfter;
      if (disableIfSameOrBefore) {
        setArrivalUnavailableCell({
          key: "".concat(tableCell.rowIndex, "-").concat(tableCell.columnIndex),
          status: 'UnavailableDueToMinimumStay'
        });
        return;
      } else if (disableIfAfter) {
        return;
      } else {
        setArrivalUnavailableCell({
          key: '',
          status: ''
        });
      }

      //if mobile, second click is select the end cell, same logic as the onmouseover
      onMouseOver(rowIndex, columnIndex, selectionVisible, selection, setSelection, tableCells, tableCell, firstSelection, minRange, maxRange, blockCells, checkoutOnlyCells, setArrivalUnavailableCell);
      clearSelection(firstSelection);
      setSelectionVisible(false);
    }
  }
}
export function onMouseOver(rowIndex, columnIndex, selectionVisible, selection, setSelection, tableCells, tableCell, firstSelection, minRange, maxRange, blockCells, checkoutOnlyCells, setArrivalUnavailableCell) {
  //check if first clicked
  if (selectionVisible) {
    var firstSelectionTableCell = getTableCell(tableCells, firstSelection.current.rowCurrentIndex, firstSelection.current.columnCurrentIndex);

    //check if the mouse overed cell is valid
    if (tableCell && !tableCell.virtual && dayjs(tableCell.date).isAfter(dayjs(firstSelectionTableCell.date).subtract(1, 'day'))) {
      if (tableCell.status === 'Block') return;
      var _checkIsCellDisabledA4 = checkIsCellDisabledAfterFirstSelection(tableCell, firstSelection, minRange, maxRange, tableCells, blockCells, checkoutOnlyCells),
        disableIfSameOrBefore = _checkIsCellDisabledA4.disableIfSameOrBefore,
        disableIfAfter = _checkIsCellDisabledA4.disableIfAfter;
      if (disableIfSameOrBefore) {
        setArrivalUnavailableCell({
          key: "".concat(tableCell.rowIndex, "-").concat(tableCell.columnIndex),
          status: 'UnavailableDueToMinimumStay'
        });
        return;
      } else if (disableIfAfter) {
        return;
      } else {
        setArrivalUnavailableCell({
          key: '',
          status: ''
        });
      }
      var currentRow = selection.rowCurrentIndex;
      var rowStart = rowIndex >= currentRow ? currentRow : rowIndex;
      var rowEnd = !(rowIndex >= currentRow) ? currentRow : rowIndex;
      var currentCol = selection.columnCurrentIndex;
      var columnStart = -1;
      if (rowIndex < firstSelection.current.rowStartIndex) {
        columnStart = columnIndex;
      } else if (rowIndex === firstSelection.current.rowStartIndex) {
        if (columnIndex < firstSelection.current.columnStartIndex) {
          columnStart = columnIndex;
        } else {
          columnStart = firstSelection.current.columnStartIndex;
        }
      } else {
        columnStart = firstSelection.current.columnStartIndex;
      }
      var columnEnd = -1;
      if (rowIndex < firstSelection.current.rowEndIndex) {
        columnEnd = firstSelection.current.columnEndIndex;
      } else if (rowIndex === firstSelection.current.rowEndIndex) {
        if (columnIndex < firstSelection.current.columnEndIndex) {
          columnEnd = firstSelection.current.columnEndIndex;
        } else {
          columnEnd = columnIndex;
        }
      } else {
        columnEnd = columnIndex;
      }

      // const columnStart = rowIndex  firstSelect.rowStartIndex && columnIndex >= firstSelect.columnStartIndex ? firstSelect.columnStartIndex : columnIndex;
      // const columnEnd = !(columnIndex >= currentCol) ? currentCol : columnIndex;

      setSelection({
        rowStartIndex: rowStart,
        rowEndIndex: rowEnd,
        rowCurrentIndex: currentRow,
        columnStartIndex: columnStart,
        columnEndIndex: columnEnd,
        columnCurrentIndex: currentCol
      });
    }
  }
}
export function onMouseUp(selection, tableCells, onSelect) {
  var rowStartIndex = selection.rowStartIndex,
    rowEndIndex = selection.rowEndIndex,
    columnStartIndex = selection.columnStartIndex,
    columnEndIndex = selection.columnEndIndex;
  if (rowStartIndex > -1 && rowEndIndex > -1 && columnStartIndex > -1 && columnEndIndex > -1) {
    if (onSelect) {
      var selectProp = {
        startDate: '',
        endDate: ''
      };
      var selectedTableCells = getSelectedTableStartEndCell(tableCells, rowStartIndex, rowEndIndex, columnStartIndex, columnEndIndex);
      if (selectedTableCells.length === 2) {
        selectProp.startDate = selectedTableCells[0].date || '';
        selectProp.endDate = selectedTableCells[1].date || '';
      } else if (selectedTableCells.length === 1) {
        selectProp.startDate = selectedTableCells[0].date || '';
        selectProp.endDate = '';
      }
      onSelect(selectProp);
    }
  }
}
export function onSectionRenderJumpToToday(init, todayScrollTop, monthDate, setCustomScrollTop, cellHeight) {
  if (init.current) return;
  function getRowsUntilThisMonth(year, month) {
    // 获取该月的第一天
    var firstDayOfMonth = new Date(year, month, 1);
    var firstDayOfWeek = firstDayOfMonth.getDay(); // 星期天是0，星期一是1，...
    // 获取该月的最后一天
    var lastDayOfMonth = new Date(year, month + 1, 0);
    var totalDaysInMonth = lastDayOfMonth.getDate(); // 获取该月天数
    // 计算需要多少行（周）
    var totalCells = totalDaysInMonth + firstDayOfWeek; // 天数 + 偏移量
    var numberOfRows = Math.ceil(totalCells / 7); // 每行7天
    return numberOfRows;
  }
  function getRowsUntilToday() {
    // 获取该月的第一天
    var year = dayjs().year(); // Returns the year as a number
    var month = dayjs().month(); // Returns the month (0-based: 0 = January, 11 = December)
    var day = dayjs().date(); // Returns the day of the month
    var firstDayOfMonth = new Date(year, month, 1);
    var firstDayOfWeek = firstDayOfMonth.getDay(); // 星期天是0，星期一是1...
    // 计算今天之前的总单元格数，包括今天
    var totalCellsUntilToday = day + firstDayOfWeek;
    // 计算今天之前的行数
    var rowsUntilToday = Math.ceil(totalCellsUntilToday / 7);
    return rowsUntilToday;
  }
  var months = Object.keys(monthDate);
  var numberOfRow = 0;
  for (var i = 0; i < months.length; i++) {
    for (var j = 0; j < monthDate[months[i]].length; j++) {
      if (monthDate[months[i]][j] === dayjs().format('YYYY-MM-DD')) {
        numberOfRow += getRowsUntilToday();
        var scrollTop = numberOfRow * cellHeight;
        setCustomScrollTop(scrollTop);
        todayScrollTop.current = scrollTop;
        init.current = true;
        return;
      }
    }
    var year = Number(months[i].split('-')[0]);
    var month = Number(months[i].split('-')[1]) - 1;
    numberOfRow += getRowsUntilThisMonth(year, month) + 1; //title take 1 row
  }
}
export function getBlockCheckoutOnlyMinimumNightCells(minRange, blockedDates) {
  var checkoutOnlyCells = [];
  var unavailableDueToMinimumStayCells = [];
  var blockedDatesSet = new Set(blockedDates);
  var _loop = function _loop() {
    var blockedDate = dayjs(blockedDates[i]);
    var checkedDate = [];
    var canMeetMinDate = true;
    for (var j = 1; j <= minRange + 1; j++) {
      var previousDateString = blockedDate.subtract(j, 'day').format('YYYY-MM-DD');
      if (blockedDates.includes(previousDateString)) {
        canMeetMinDate = false;
        break;
      }
      checkedDate.push(previousDateString);
    }
    if (canMeetMinDate) {
      checkedDate.forEach(function (date, index) {
        if (index === 0) {
          checkoutOnlyCells.push(date);
        } else {
          //checked date checking minRange + 1, so last one can be selected as startDate
          if (index !== checkedDate.length - 1) {
            unavailableDueToMinimumStayCells.push(date);
          }
        }
      });
    } else {
      checkedDate.forEach(function (date) {
        return blockedDatesSet.add(date);
      });
    }
  };
  for (var i = 0; i < blockedDates.length; i++) {
    _loop();
  }
  return {
    checkoutOnlyCells: checkoutOnlyCells,
    unavailableDueToMinimumStayCells: unavailableDueToMinimumStayCells,
    updatedBlockCells: Array.from(blockedDatesSet)
  };
}
export function getToolTipPosition(tableCell) {
  if (tableCell.columnIndex === 6) {
    return 'date-picker-table-row-column-arrival-unavailable-tooltip-right';
  } else if (tableCell.columnIndex === 0) {
    return 'date-picker-table-row-column-arrival-unavailable-tooltip-left';
  } else {
    return 'date-picker-table-row-column-arrival-unavailable-tooltip-middle';
  }
}
function getTableCellByDate(tableCells, date) {
  var _tableCells$filter2;
  return (_tableCells$filter2 = tableCells.filter(function (i) {
    return i.date === date;
  })) === null || _tableCells$filter2 === void 0 ? void 0 : _tableCells$filter2[0];
}
export function setSelectionByValue(tableCells, value, setSelection, firstSelection) {
  if (value.length === 2) {
    var startCell = getTableCellByDate(tableCells, value[0]);
    var endCell = getTableCellByDate(tableCells, value[1]);
    clearSelection(firstSelection);
    setSelection({
      rowStartIndex: startCell.rowIndex,
      rowEndIndex: endCell.rowIndex,
      rowCurrentIndex: endCell.rowIndex,
      columnStartIndex: startCell.columnIndex,
      columnEndIndex: endCell.columnIndex,
      columnCurrentIndex: endCell.columnIndex
    });
  } else if (value.length === 1) {
    var _startCell = getTableCellByDate(tableCells, value[0]);
    var startCellDimension = {
      rowStartIndex: _startCell.rowIndex,
      rowEndIndex: _startCell.rowIndex,
      rowCurrentIndex: _startCell.rowIndex,
      columnStartIndex: _startCell.columnIndex,
      columnEndIndex: _startCell.columnIndex,
      columnCurrentIndex: _startCell.columnIndex
    };
    setSelection(startCellDimension);
    firstSelection.current = startCellDimension;
  }
}